export const SubscriptionDetailsFormName = 'subscription';

export enum SubscriptionDetailsFormFields {
  PromoCode = 'promoCode',
}
